import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'animate.css';
import CollectFund from '../assets/helping-1.jpg';
import SkillDev from '../assets/helping-2.png';
import CareerProgram from '../assets/helping-3.jpg';
import ActivityVideo from '../assets/activity.mp4';
import NamamiGange from '../assets/cause/namami-gange.jpg';
import ClothesDonation from '../assets/cause/clothes-donation.jpg';
import PlantationProject from '../assets/cause/plantation-project.jpg';
import FoodDonation from '../assets/cause/food-donation.jpg';
import BetiPadhao from '../assets/cause/beti-padhao.JPG';
import GreenIndia from '../assets/cause/green-india.JPG';
import Medicalcamp from '../assets/cause/medical-camp.jpg';
import WomenEmpowerment from '../assets/cause/women-empowerment.jpg';
import { Link } from 'react-router-dom';
import Counter from '../general/Counter';
import { useNavigate } from 'react-router-dom';



const Home = () => {

  const navigate = useNavigate();

  return (
    <>
      {/* banner section */}
      <section className='banner-bg'>
        <div className='container'>

          <div className='col-lg-7 col-12'>
            <p className='fs-4 fw-600'>Get Started Today.</p>
            <div className='banner-heading'>Donate for the People in Need</div>
            <p className='fs-5 my-4'>Anvi Foundation is a charity focused on skill development, donations, and supporting various social welfare initiatives for communities in need.</p>
            <button className='banner-btn' onClick={() => navigate('/about')}>Know More</button>
          </div>

        </div>
      </section>
      {/* banner section ends */}


      {/* Helping Reason */}
      <section className='my-5'>
        <div className='container text-center'>

          <p className='sec-heading'>Reason of Helping</p>
          <hr className='sec-heading-hr m-auto' />

          <div className='row mt-5 text-start'>

            <div className='col-lg-4 col-md-6 col-12 my-2 px-4'>
              <div className='helping-img-outer'>
              <img src={CollectFund} className='helping-img' alt='Reason Helping' />
              <div className='helping-info'>
              <p className='sec-heading5'>Collecting Fund</p>
              <p>We collect fund for feeding poor people, planting more trees, educating poor students, cleaning water bodies and more.</p>
              <Link className='read-link' to='/donation'>— &nbsp;Read More</Link>
              </div>
              </div>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-2 px-4'>
              <div className='helping-img-outer'>
              <img src={SkillDev} className='helping-img' alt='Reason Helping' />
              <div className='helping-info'>
              <p className='sec-heading5'>Skill Development</p>
              <p>We offer various programs for skill development vocabulory training, PMKY, UPSDM, PM Sankalp yojana, and more.</p>
              <Link className='read-link' to='/skill-development'>— &nbsp;Read More</Link>
              </div>
              </div>
            </div>
            
            <div className='col-lg-4 col-md-6 col-12 my-2 px-4'>
              <div className='helping-img-outer'>
              <img src={CareerProgram} className='helping-img' alt='Reason Helping' />
              <div className='helping-info'>
              <p className='sec-heading5'>Career Programs</p>
              <p>Donate for the people who need your help and help in transforming their lives. Provide them food, education, & shelter.</p>
              <Link className='read-link' to='/careers'>— &nbsp;Read More</Link>
              </div>
              </div>
            </div>



          </div>
          {/* row ends */}

        </div>
      </section>
      {/* Helping Reason ends */}


      {/* Latest Activity Section */}
      <section className='activity-bg'>
        <div className='row'>

          <div className='col-lg-5 col-12'>
            {/* <img src={LatestActivity} className='img-fluid w-100' alt='latest activity' /> */}
            <video className='w-100 h-100' autoPlay loop muted>
        <source src={ActivityVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
          </div>

          <div className='col-lg-5 col-12 px-lg-5 px-md-5 px-4 py-5'>

            <p className='sec-heading'>Watch our latest Activities</p>
            {/* <hr className='sec-heading-hr' /> */}

            <p className='my-4 text-muted'>Stay updated with our latest activities! From community events to innovative projects, explore how we’re making an impact.
              Follow us to see what’s new and exciting at Anvi Foundation!<br /><br />
              We are dedicated trust focused on empowering individuals through skill development, education, and community welfare initiatives. We aim to create opportunities for underprivileged communities, fostering self-reliance and sustainable growth. Join us in our mission to transform lives and build a brighter, more equitable future for all</p>
            <button className='donate-btn rounded-circle px-3 fs-3 py-2 animate__animated animate__pulse animate__infinite'>
              <i className="fa-solid fa-circle-play"></i></button>

          </div>

        </div>
      </section>
      {/* Latest Activity Section ends */}


      {/* Popular Causes */}
      <section className='my-5'>
        <div className='container text-center'>

          <p className='sec-heading'>Donation Causes</p>
          <hr className='sec-heading-hr m-auto' />


          <Swiper className='py-5'
            spaceBetween={40}
            slidesPerView={3}
            onSlideChange={() => console.log('slide change')}
            onSwiper={(swiper) => console.log(swiper)}
            modules={[Autoplay]}
            loop={true}
            autoplay={{
              delay: 2000
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              768: {
                // width: 768,
                slidesPerView: 2,
              },
              992: {
                slidesPerView: 3,
              }
            }}
          >

            <SwiperSlide className='donation-card'>
              <div className='donation-img-outer'>
                <img src={NamamiGange} className='donation-img' alt='Donation causes' /></div>

              <div className='px-4'>
                <p className='sec-heading5 my-3'>Namami Gange Mission</p>
                <hr />
                <p className='text-muted'>Support efforts to purify and restore water sources, ensuring cleaner environments and healthier ecosystems.</p>

              </div>
            </SwiperSlide>

            <SwiperSlide className='donation-card'>
              <div className='donation-img-outer'>
                <img src={ClothesDonation} className='donation-img' alt='Donation causes' /></div>

              <div className='px-4'>
                <p className='sec-heading5 my-3'>Clothes for Everyone</p>
                <hr />
                <p className='text-muted'>Donate clothing to underprivileged communities, promoting warmth, dignity, and comfort for people in need.</p>

              </div>
            </SwiperSlide>

            <SwiperSlide className='donation-card'>
              <div className='donation-img-outer'>
                <img src={PlantationProject} className='donation-img' alt='Donation causes' /></div>

              <div className='px-4'>
                <p className='sec-heading5 my-3'>Plantation Project</p>
                <hr />
                <p className='text-muted'>Contribute to reforestation initiatives, improving air quality, combating climate change, and preserving natural habitats.</p>

              </div>
            </SwiperSlide>

            <SwiperSlide className='donation-card'>
              <div className='donation-img-outer'>
                <img src={FoodDonation} className='donation-img' alt='Donation causes' /></div>

              <div className='px-4'>
                <p className='sec-heading5 my-3'>Help to Provide Food</p>
                <hr />
                <p className='text-muted'>Provide nutritious meals to those in need, combating hunger and malnutrition worldwide.</p>

              </div>
            </SwiperSlide>

            <SwiperSlide className='donation-card'>
              <div className='donation-img-outer'>
                <img src={BetiPadhao} className='donation-img' alt='Donation causes' /></div>

              <div className='px-4'>
                <p className='sec-heading5 my-3'>Beti Bachao, Beti Padhao</p>
                <hr />
                <p className='text-muted'>The program focuses on empowering girls and encouraging their overall development.</p>

              </div>
            </SwiperSlide>

            <SwiperSlide className='donation-card'>
              <div className='donation-img-outer'>
                <img src={GreenIndia} className='donation-img' alt='Donation causes' /></div>

              <div className='px-4'>
                <p className='sec-heading5 my-3'>Clean India, Green India</p>
                <hr />
                <p className='text-muted'>Improving sanitation, promoting waste management, and encouraging environmental conservation.</p>

              </div>
            </SwiperSlide>

            <SwiperSlide className='donation-card'>
              <div className='donation-img-outer'>
                <img src={Medicalcamp} className='donation-img' alt='Donation causes' /></div>

              <div className='px-4'>
                <p className='sec-heading5 my-3'>Free Medical/ Yoga Camp</p>
                <hr />
                <p className='text-muted'>Healthcare services and wellness practices to improve physical and mental health.</p>

              </div>
            </SwiperSlide>

            <SwiperSlide className='donation-card'>
              <div className='donation-img-outer'>
                <img src={WomenEmpowerment} className='donation-img' alt='Donation causes' /></div>

              <div className='px-4'>
                <p className='sec-heading5 my-3'>Women Empowerment</p>
                <hr />
                <p className='text-muted'>Aims to reduce gender inequality, and encourage education among women.</p>

              </div>
            </SwiperSlide>


          </Swiper>

        </div>
      </section>
      {/* Popular Causes ends */}

      <Counter />


      {/* Contact Section */}
      <section className='my-5'>
        <div className='container text-center'>

          <p className='sec-heading'>Get in Touch</p>
          <hr className='sec-heading-hr m-auto' />

          <p className='my-4'>Be a part of our community & support our foundation. Your contributon matters.</p>

          <button className='donate-btn' onClick={() => navigate('/contact')}>Contact Now</button>

        </div>
      </section>
      {/* Contact Section ends */}


    </>
  )
}

export default Home
